<template>
  <div :class="['logs-box', {hide:!logs.show}]">
    <div class="heading">Logs</div>

    <div class="logs-body" >
      <div class="empty-state" v-show="!logs.list.length">
        <i class="fa fa-clipboard-list fa-4x"></i>
        <span>{{ $t('rsvpDetails.activityLogs.emptyState') }}</span>
      </div>

      <div v-for="(log, i) in logs.list" :key="i" @click="log.open = !log.open"
        :class="['l-box d-flex align-start', {open:log.open}]">
        <div>
          <i class="fa fa-plus-circle" v-if="!log.open"></i>
          <i class="fa fa-minus-circle" v-else></i>
        </div>
        <div>
          <div class="l-date">{{ log.date }}</div>
          <div class="l-action">{{ actionLabel(log.type) }}</div>

          <transition name="slide-down">
            <div v-show="log.open">
              <div class="l-admin">
                <div>Admin ID: <b>{{ log.admin.id }}</b></div>
                <div>Admin Email: <b>{{ log.admin.email }}</b></div>
              </div>
  
              <div v-for="(field, k) in log.fields" :key="k" class="l-field" v-if="['enable', 'type'].indexOf(k) === -1">
                <div class="l-label">{{ relabel(k) }} <i>({{ k }})</i></div>
                <div class="l-value">{{ field }}</div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ft from '@/modules/api/featureToggle'

export default {
  name: 'logs',
  computed: {
    pricing () { return this.$store.state.pricing },
    logs () { return this.pricing.logs },
    serviceArea () { return this.pricing.serviceArea },
    _current () { return this.logs.current }
  },
  methods: {
    getLogs () {
      let self = this
      if (self.logs.loading || !self.serviceArea.activeId) return

      self.$store.commit('pricing/setLogsData', {loading: true})
      self.$sdk.get(`/servicearea/${self.serviceArea.activeId}/logs`, {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.$store.commit('pricing/setLogsData', {loading: false})
        if (r.error) {
          alert('something went wrong:', r.error.message)
          return
        }
        let logs = []
        let dateFormat = 'MM/DD/YYYY ' + ft.timeFormat(self, true)
        r.list.forEach(log => {
          logs.push({
            type: log.type,
            admin: {
              id: log.adminId,
              email: log.adminEmail
            },
            date: moment(log.created, 'X').tz('America/Los_Angeles').format(dateFormat),
            serviceTypeId: log.serviceTypeId,
            fields: log.updates,
            open: false
          })
        })
        self.$store.commit('pricing/setLogsData', {list: logs})
      }, '2.0')
    },
    actionLabel (x) {
      if (x === 'geofence_update') return 'Geofence Update'
      if (x === 'service_pricing') return 'Service Pricing'
      if (x === 'service_pickuptype') return 'Service Pickup Type'
    },
    relabel (x) {
      if (x === 'pickupType') return 'Pickup Type'
      if (x === 'pickupFee') return 'Pickup Fee'
      if (x === 'airportFee') return 'Airport Fee'
      if (x === 'gasFee') return 'Gas Fee'
      if (x === 'discountAmount') return 'Discount Amount'
      if (x === 'charterFare') return 'Charter - Base Rate'
      if (x === 'minuteRate') return 'Per Minute Rate'
      if (x === 'provCharterBase') return 'Prov Base Fee'
      if (x === 'provCharterRate') return 'Prov Per Minute Rate'
      if (x === 'provCharterDiscount') return 'Prov Discount Rate'
      if (x === 'rentFare') return 'Rent Fare'
      if (x === 'rentRate') return 'Hourly Rent Rate'
      if (x === 'rentRateDaily') return 'Daily Rent Rate'
      if (x === 'rentRateWeekend') return 'Weekend Rent Rate'
      return x
    }
  },
  watch: {
    _current (val) {
      if (val && this.logs.show) this.getLogs()
    }
  }
}
</script>

<style lang="scss" scoped>
$right-panel-width: 400px;

.logs-box{
  position: fixed;
  z-index: 2;
  right: 0;
  top: 0;
  width: $right-panel-width;
  height: 100%;
  box-shadow: -2px 0 4px rgba(0,0,0,0.2);
  background: #fff;
  transition: all .2s ease;

  &.hide{
    right: -#{$right-panel-width};
    box-shadow: -2px 0 8px rgba(0,0,0,0.0);
  }

  .heading{
    font-size:21px;
    font-weight: 600;
    letter-spacing: .7px;
    color: #333;
    padding: 0 20px;
    line-height: 49px;
    background-color: #f4f8f9;
  }

  .logs-body{
    display: block;
    height: calc(100% - 50px);
    background: #fff;
    overflow-y: auto;
    padding: 20px;
    border-top: 1px solid #ccc;
  }
}
.l-box{
  border: 1px solid #ddd;
  width: 100%;
  max-height:auto;
  padding: 10px;
  background: #fafafa;
  overflow: hidden;
  transition: all .35s ease-in-out;
  cursor: pointer;
  margin-bottom: 10px;
  gap: 10px;
  font-size: 11px;
  letter-spacing: .5px;
  color: #666;

  &.open{
    background: #fff8dc;
  }
}
.l-date{
  line-height: 1;
  margin-bottom: 3px;
}
.l-action{
  font-weight: 600;
}
.l-admin{
  margin: 15px 0 20px;
}
.l-field{
  margin-bottom: 15px;
}
.l-label{
  line-height: 1;
  letter-spacing: .6px;
  margin-bottom: 3px;

  i{
    display: inline-block;
    margin-left: 3px;
  }
}
.l-value{
  font-weight: 600;
  color: #555;
}

.empty-state{
  padding: 30px;
  font-size: 18px;
  color: #999;
  text-align: center;

  .fa{
    display: block;
    margin-bottom: 5px;
    color: #ccc;
    text-shadow:0 0 5px rgba(255,255,255, 1);
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .2s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Pricing/Logs.vue